import { Component, OnInit,ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { columnsModel } from 'src/app/models/customer.model';

// Need to be removed once feature work done for the same.
//View participant Table
export interface ViewParticipantData {
  globalUDPId: string;
}

const ELEMENT_DATA: ViewParticipantData[] = [
  { globalUDPId: "8912345678912342345678912345678"},
  { globalUDPId: "5678912345678912342345678912345"}, 
  { globalUDPId: "8912345623456789123478912345678"},
  { globalUDPId: "5678912323456789123421212232345"}, 
  { globalUDPId: "8912345678565623456789123421591"},
  { globalUDPId: "2345673324323456789123421489145"}, 
  { globalUDPId: "5678912323456789123421212232345"}, 
  { globalUDPId: "8912345678565623456789123421591"},
  { globalUDPId: "2345673324323456789123421489145"},  
  { globalUDPId: "2345673324323456789123421489145"}, 
 ];

@Component({
  selector: 'app-view-participants',
  templateUrl: './view-participants.component.html',
  styleUrls: ['./view-participants.component.scss']
})
export class ViewParticipantsComponent implements OnInit {
  iconConfig: any;
  public dataSource: any = new MatTableDataSource<ViewParticipantData>(ELEMENT_DATA); 
  totalRecords: number = 8;
  @ViewChild('fileInput')

  public currentColumns1: columnsModel[] = [
    { field: 'globalUDPId', header: 'Global UDP ID', width: 50 },    
  ];
 

  constructor() {
    this.iconConfig = {
      iconName: 'times',
      iconType: 'fal'
    }
    
   }

  ngOnInit(): void {
  }

   /* istanbul ignore next */
   rowSelection(data) {
  }

}
